module.exports = __webpack_public_path__ + "static/media/stock-05.1259a756.jpg";